import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

// Preliminary chain key! Chain not yet supported in Viem
// However `rari` key is in PR: https://github.com/wevm/viem/pull/1741
export const rari = {
  displayName: 'Rari',
  runtime: 'evm',
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'rari' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
